import NextLink from 'next/link';
import { Image } from 'react-datocms';
import { twMerge } from 'tailwind-merge';
import type { ComponentProps } from 'react';

type ImageCardProps = {
  image?: ComponentProps<typeof Image>['data'] | null;
  imageHref?: string;
} & ComponentProps<'div'>;

// Card with an image above a bordered content box, shared by the modules that show such cards
export const ImageCard = ({ imageHref, children, image, ...props }: ImageCardProps) => (
  <div {...props}>
    {image ? (
      <div className="mt-6 px-7">
        {imageHref ? (
          <NextLink aria-hidden="true" className="block" href={imageHref} tabIndex={-1}>
            <Image data={image} />
          </NextLink>
        ) : (
          <Image data={image} />
        )}
      </div>
    ) : null}

    {children}
  </div>
);

export const ImageCardContent = ({ className, ...props }: ComponentProps<'div'>) => (
  <div
    className={twMerge(
      'relative mb-6 rounded-xl border border-base-100 bg-background px-7 pb-3 pt-7 text-left shadow-[0_1px_0_1px_var(--color-base-100)]',
      className,
    )}
    {...props}
  />
);
